var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOrder = function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 3.75a.75.75 0 0 1 .75.75v.75h4.5V4.5a.75.75 0 0 1 1.5 0v.75H16A2.75 2.75 0 0 1 18.75 8v10A2.75 2.75 0 0 1 16 20.75H8A2.75 2.75 0 0 1 5.25 18V8A2.75 2.75 0 0 1 8 5.25h.25V4.5A.75.75 0 0 1 9 3.75m5.293 3a.75.75 0 0 0 1.414 0H16c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H8c-.69 0-1.25-.56-1.25-1.25V8c0-.69.56-1.25 1.25-1.25h.293a.75.75 0 0 0 1.414 0zM9 9.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM8.25 16a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};
export default SvgOrder;